// extracted by mini-css-extract-plugin
export default {"main":"index-module__main--UQV9j","footer":"index-module__footer--InkZV"};